import { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import NumberFormat from "react-number-format";
import { messages } from '../../../../messages'

export default function (props) {
    const [amount, setAmount] = useState(props?.total);
    const [error, setError] = useState(false);
    const refund = () => {
        if (props.max >= amount) {
            props.refund(amount);
        } else {
            setError(true);
        }
    }
    return <>
        <Popup open={true} onClose={() => props?.close()}>
            <div className="refund-section">
                <h2>Refund</h2>
                <div className="refund-form">
                    <div className="mul-input-field">
                        <NumberFormat value={amount} displayType={'input'} thousandSeparator={true} prefix={'$'} onValueChange={(e) => {
                            setAmount(+e.value);
                        }} name="total" placeholder='Refund Amount'></NumberFormat>
                        <span className="error"> {error && messages.refundAmountLarge} </span>
                    </div>
                </div>
            </div>
            <div className="footer-btn">
                <button className="refund-btn cancel btn mb-0" onClick={() => props?.close()}>Cancel</button>
                <button className="refund-btn btn mb-0" onClick={() => refund()}>Refund</button>
            </div>
        </Popup>
    </>
}